export enum PriceTypeEnum {
  priceRange,
  price,
  msrpRange,
  msrp
}
